import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import jojoAccount from '@jojo/account-sdk';
import { Sentry } from '@woulsl/sentry-config';
import session from '@woulsl/storage/session';
import { isJoJoUp, jojoAccountConfig } from '@/const';
var T_SEC_TURING_TOKEN_KEY = 'T_SEC_TURING_TOKEN'; // 天御图灵盾DeviceToken存储Key

jojoAccount.config(jojoAccountConfig);
/**
 * 获取腾讯天御图灵盾DeviceToken
 * ab开关开启则判断是否有DeviceToken， 默认返回timeout
 */

export function getTsecTuringDeviceToken() {
  try {
    return session.get(T_SEC_TURING_TOKEN_KEY) || 'timeout';
  } catch (error) {
    console.log('获取腾讯天御图灵盾DeviceToken出错： ', error);
    Sentry.captureException({
      message: "\u83B7\u53D6\u817E\u8BAF\u5929\u5FA1\u56FE\u7075\u76FEDeviceToken\u51FA\u9519\uFF1A:".concat(error === null || error === void 0 ? void 0 : error.message),
      params: ''
    }, {
      level: 'info'
    });
  }

  return '';
}
/**
 * 移除腾讯天御图灵盾DeviceToken
 */

export function removeTsecTuringDeviceToken() {
  session.remove(T_SEC_TURING_TOKEN_KEY);
}
/**
 * 初始化腾讯天御图灵盾
 */

export function initTsecTuring() {
  return __awaiter(this, void 0, void 0, function () {
    var res, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , jojoAccount.getTsecDeviceToken({
            tsecTuringABPlatformEnv: isJoJoUp ? 'jojoup' : 'jojo'
          })];

        case 1:
          res = _a.sent();

          if (res.status === 0 && res.data) {
            session.set(T_SEC_TURING_TOKEN_KEY, res.data.deviceToken);
          }

          return [3
          /*break*/
          , 3];

        case 2:
          error_1 = _a.sent();
          console.log('初始化腾讯天御图灵盾出错： ', error_1);
          Sentry.captureException({
            message: "\u521D\u59CB\u5316\u817E\u8BAF\u5929\u5FA1\u56FE\u7075\u76FE\u51FA\u9519\uFF1A:".concat(error_1 === null || error_1 === void 0 ? void 0 : error_1.message),
            params: ''
          }, {
            level: 'info'
          });
          return [3
          /*break*/
          , 3];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}